import React from 'react';
import PageTemplate from '../components/PageTemplate';

const About = () => {
  return (
    <PageTemplate
      title="About Codes AI"
      subtitle="Innovative solutions for the digital transformation era"
      breadcrumb="About Us"
    >
      <div className="content-section">
        <div className="two-column">
          <div>
            <h3>Our Mission</h3>
            <p>
              At Codes AI, we support you professionally and with foresight in the challenges posed by technological change and progress. In doing so, we always focus on one thing - people.
            </p>
            <p>
              We design efficient data pipelines for seamless analysis, unlocking valuable insights with advanced analytics and business intelligence. Our solutions ensure secure and accessible data management while automating processes and decisions with AI.
            </p>
            <ul className="feature-list">
              <li>Professional expertise in emerging technologies</li>
              <li>People-centric approach to digital transformation</li>
              <li>Comprehensive AI and data solutions</li>
              <li>Global reach with local understanding</li>
            </ul>
          </div>
          <div>
            <div className="stats-grid">
              <div className="stat-item">
                <span className="stat-number">100+</span>
                <span className="stat-label">Projects Completed</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">50+</span>
                <span className="stat-label">Happy Clients</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">5+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat-item">
                <span className="stat-number">24/7</span>
                <span className="stat-label">Support</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>Our Core Values</h2>
        <div className="content-grid">
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-lightbulb"></i>
            </div>
            <h4>Innovation</h4>
            <p>We constantly push the boundaries of technology to deliver cutting-edge solutions that drive business growth and transformation.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-handshake"></i>
            </div>
            <h4>Partnership</h4>
            <p>We believe in building long-term partnerships with our clients, working together to achieve sustainable success and growth.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-shield-alt"></i>
            </div>
            <h4>Quality</h4>
            <p>We maintain the highest standards in everything we do, ensuring reliability, security, and excellence in all our deliverables.</p>
          </div>
          <div className="content-card">
            <div className="icon">
              <i className="fas fa-users"></i>
            </div>
            <h4>People First</h4>
            <p>Our people-centric approach ensures that technology serves humanity, creating solutions that improve lives and experiences.</p>
          </div>
        </div>
      </div>

      <div className="content-section">
        <h2>Our Expertise</h2>
        <div className="two-column">
          <div>
            <h4>Technology Stack</h4>
            <p>We work with the latest technologies and frameworks to deliver robust, scalable solutions.</p>
            <ul className="feature-list">
              <li>Artificial Intelligence & Machine Learning</li>
              <li>Cloud Computing (AWS, Azure, GCP)</li>
              <li>Data Engineering & Analytics</li>
              <li>Mobile & Web Development</li>
              <li>DevOps & Automation</li>
              <li>Blockchain & Smart Contracts</li>
            </ul>
          </div>
          <div>
            <h4>Industry Experience</h4>
            <p>Our team has extensive experience across various industries, bringing domain knowledge to every project.</p>
            <ul className="feature-list">
              <li>Healthcare & Biotechnology</li>
              <li>Financial Services & FinTech</li>
              <li>Retail & E-commerce</li>
              <li>Manufacturing & IoT</li>
              <li>Education Technology</li>
              <li>Energy & Utilities</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="cta-section">
        <h3>Ready to Transform Your Business?</h3>
        <p>Let's discuss how Codes AI can help you achieve your digital transformation goals.</p>
        <button className="btn btn-primary">Get in Touch</button>
      </div>
    </PageTemplate>
  );
};

export default About; 